export default __webpack_public_path__ + "static/media/logo-white.dfbba7f4.svg";